
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
    
const MappingTenantModal = (props) => {

    const {openList,setOpenList,checkedItems,handleListChange,handleListSubmit,tenantId,loading} = props;

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4
    };

    return (
        <Modal open={openList} onClose={() => setOpenList(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h4" component="h2">
                App List
            </Typography>

            <Typography id="modal-modal-title" variant="h4" component="h2">
                {checkedItems?.map((p, i) => (
                    <FormControlLabel key={i} control={<Checkbox checked={p.TenantAppMapping.isactive} onChange={() => handleListChange(p.app_id)} name={p.app_name} />} label={p.app_name} />
                ))}
            </Typography>

            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {loading ? <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} /> :
                <Button type="submit" variant="contained" color="primary" onClick={() => handleListSubmit(tenantId)}>
                    Submit
                </Button>}
            </Typography>
        </Box>
    </Modal>
    )
}

export default MappingTenantModal
    
   